define('view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemView',['require','lib/view/CompositeView','view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemHourView','model/GroupedTimeSlotsModel','lib/view/UnwrapBehavior'],function (require) {

    var CompositeView = require('lib/view/CompositeView');
    var TimeFlexibleProviderItemHourView = require('view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemHourView');
    var GroupedTimeSlotsModel = require('model/GroupedTimeSlotsModel');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    return CompositeView.extend({

        template: '#time_flexible_provider_item_view',
        childView: TimeFlexibleProviderItemHourView,
        childViewContainer: '.sb-flexible-provider-timeline',

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        childViewOptions: function (model, index) {
            return {
                clientTimeZone: this.getOption('clientTimeZone'),
                provider: this.model.get('id'),
            };
        },

        initialize: function () {
            this._updateCollection();

            CompositeView.prototype.initialize.apply(this);
        },

        _updateCollection: function () {
            this.collection = this.model.collection.getCollectionGroupedByTimeline(this.getOption('timeline'));
        },

        serializeData: function () {
            var result = CompositeView.prototype.serializeData.apply(this);

            result.is_empty_day = false;
            if(result.timeCollection) {
                result.is_empty_day = !_.findWhere(result.timeCollection, {'type': 'free'});
            }
            result.is_day_off = this.getOption('isDayOff');
            result.is_wl_available = this.getOption('isWlAvailable');

            return result;
        },

        onChildviewHoverTime: function (view, data) {
            this.triggerMethod('hover:providertime', {
                model: data.model,
                provider: this.model.get('id')
            });
        },

        onChildviewSelectTime: function (view, data) {
            this.triggerMethod('select:providertime', {
                model: data.model,
                provider: this.model.get('id')
            });
        }

    });

});

